/**
 * Production-safe logging utility
 * Only logs debug/info/warn in development mode
 * Always logs errors in production for monitoring
 */

import { captureException, captureMessage } from '@/lib/sentry';

const isDev = import.meta.env.DEV;

export const logger = {
  log: (...args: any[]) => {
    if (isDev) console.log(...args);
  },
  
  warn: (...args: any[]) => {
    if (isDev) console.warn(...args);
  },
  
  info: (...args: any[]) => {
    if (isDev) console.info(...args);
  },
  
  error: (...args: any[]) => {
    const message = args[0]?.toString?.() || 'Unknown error';
    const context = args.slice(1);
    
    // Send to Sentry in production
    if (args[0] instanceof Error) {
      captureException(args[0], context[0]);
    } else {
      captureMessage(message, 'error');
    }
    
    // Always log errors with context for monitoring
    console.error('[Command OS]', new Date().toISOString(), ...args);
  },
  
  debug: (...args: any[]) => {
    if (isDev) console.debug(...args);
  },
};
